<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" scrollable :mask="false" draggable class="single_row_edit" width="700">
    <div class="pstn_content">
      <div class="input_single">
        <div class="font_style_set"><span class="span_must">*</span>网页名称:</div>
        <Input v-model="channelName" maxlength="50" class="input_content" type="text"  placeholder="请输入网页名称(长度不超过50个字符)"/>
      </div>
      <div class="input_single">
        <div class="font_style_set">分时段:</div>
        <Select class="input_content" :transfer="true" v-model="channelPeriod" placeholder="请选择是否启用分时段业务">
          <Option :value="'0'">关闭</Option>
          <Option :value="'1'">开启</Option>
        </Select>
        <div class="fixed_operation_btn">
        <Tooltip class="tips_font" placement="left" style="margin-top:-3px;">
                      <div slot="content">
                          <p>分时段功能需要在</p>
                          <p>(系统管理->时间定义)或(系统管理->CTI配置->热线号码->时间定义)</p>
                          <p>中配置后生效</p>
                      </div>
                    <img src="../../../assets/image/homeAsk.png"/>
        </Tooltip>
        </div>
      </div>

<!-- 不开启分时段 -->
      <div class="input_single" v-if="channelPeriod == '0'">
        <div class="font_style_set">分配策略:</div>
          <Select class="input_content" :transfer="true" v-model="channelAllocatStrategy" placeholder="请选择分配策略">
            <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
      </div>
      <div class="input_single" v-if="channelPeriod == '0'">
        <div class="font_style_set">分配类型:</div>
          <Select class="input_content" :transfer="true" v-model="channelAllocatType">
            <Option :value="'1'" >导航菜单</Option>
            <Option :value="'2'" >员工</Option>
          </Select>
        </div>
      </div>
      <div class="input_single" v-if="'1' == channelAllocatType && '0' == channelPeriod">
        <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
          <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelAllocatNavList" multiple placeholder="请选择导航菜单" clearable>
            <Option v-for="item in channelNavList" :value="item.id" :key="item.id+'_id'">{{ item.navName }}</Option>
          </Select>
      </div>
      <div class="input_single" v-if="'2' == channelAllocatType && '0' == channelPeriod">
        <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
          <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelAllocatEmpList" multiple placeholder="请选择员工" clearable>
            <Option v-for="item in chatEmpList" :value="item.agentNo" :key="item.agentNo+'_agentNo'">{{ item.agentNo }}</Option>
          </Select>
      </div>
      <!-- 开启分时段 -->
      <Tabs v-if="channelPeriod == '1'">
            <TabPane label="工作时间">
                  <div class="input_single">
                    <div class="font_style_set">分配策略:</div>
                      <Select class="input_content" :transfer="true" v-model="channelWorkStrategy" placeholder="请选择分配策略">
                        <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                  </div>
                  <div class="input_single">
                    <div class="font_style_set">分配类型:</div>
                      <Select class="input_content" :transfer="true" v-model="channelWorkType">
                        <Option :value="'1'" >导航菜单</Option>
                        <Option :value="'2'" >员工</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelWorkType == '1'">
                    <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelWorkNavList" multiple placeholder="请选择导航菜单" clearable>
                        <Option v-for="item in channelNavList" :value="item.id" :key="item.id+'_id'">{{ item.navName }}</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelWorkType == '2'">
                    <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelWorkEmpList" multiple placeholder="请选择员工" clearable>
                        <Option v-for="item in chatEmpList" :value="item.agentNo" :key="item.agentNo+'_agentNo'">{{ item.agentNo }}</Option>
                      </Select>
                  </div>
            </TabPane>
            <TabPane label="下班时间">
                <div class="input_single">
                  <div class="font_style_set">分配策略:</div>
                    <Select class="input_content" :transfer="true" v-model="channelHomeStrategy" placeholder="请选择分配策略">
                      <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </div>
                <div class="input_single">
                    <div class="font_style_set">分配类型:</div>
                      <Select class="input_content" :transfer="true" v-model="channelHomeType">
                        <Option :value="'1'" >导航菜单</Option>
                        <Option :value="'2'" >员工</Option>
                      </Select>
                </div>
                <div class="input_single" v-if="channelHomeType == '1'">
                  <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
                    <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHomeNavList" multiple placeholder="请选择导航菜单" clearable>
                      <Option v-for="item in channelNavList" :value="item.id" :key="item.id+'_id'">{{ item.navName }}</Option>
                    </Select>
                </div>
                <div class="input_single" v-if="channelHomeType == '2'">
                  <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
                    <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHomeEmpList" multiple placeholder="请选择员工" clearable>
                      <Option v-for="item in chatEmpList" :value="item.agentNo" :key="item.agentNo+'_agentNo'">{{ item.agentNo }}</Option>
                    </Select>
                </div>
            </TabPane>
            <TabPane label="节假日">
                  <div class="input_single">
                    <div class="font_style_set">分配策略:</div>
                      <Select class="input_content" :transfer="true" v-model="channelHolidayStrategy" placeholder="请选择分配策略">
                        <Option v-for="item in strategyList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                      </Select>
                  </div>
                  <div class="input_single">
                    <div class="font_style_set">分配类型:</div>
                      <Select class="input_content" :transfer="true" v-model="channelHolidayType">
                        <Option :value="'1'" >导航菜单</Option>
                        <Option :value="'2'" >员工</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelHolidayType == '1'">
                    <div class="font_style_set"><span class="span_must">*</span>分配导航菜单:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHolidayNavList" multiple placeholder="请选择导航菜单" clearable>
                        <Option v-for="item in channelNavList" :value="item.id" :key="item.id+'_id'">{{ item.navName }}</Option>
                      </Select>
                  </div>
                  <div class="input_single" v-if="channelHolidayType == '2'">
                    <div class="font_style_set"><span class="span_must">*</span>分配员工:</div>
                      <Select class="input_content select_cls" :transfer="true" :max-tag-count="3" filterable v-model="channelHolidayEmpList" multiple placeholder="请选择员工" clearable>
                        <Option v-for="item in chatEmpList" :value="item.agentNo" :key="item.agentNo+'_agentNo'">{{ item.agentNo }}</Option>
                      </Select>
                  </div>
            </TabPane>>
      </Tabs>
    <div >
          <p style="color:#535151;font-weight:bold;font-size:15px;margin-left:10%">按钮配置</p>
          <div>
              <div class="input_single">
                <div class="font_style_set"><span class="span_must">*</span>按钮名称:</div>
                <Input v-model="btnName" maxlength="10" class="input_content" type="text" title="按钮名称" placeholder="请输入按钮名称(长度不超过10个字符)"/>
              </div>
              <div class="input_single">
                <div class="font_style_set">按钮样式:</div>
                <Select v-model="btnStyle" class="input_content" >
                    <Option :value="'0'">不显示</Option>
                    <Option :value="'1'">方形(纵向)</Option>
                    <Option :value="'2'">方形(横向)</Option>
                    <Option :value="'3'">圆形</Option>
                    <Option :value="'4'">图片</Option>
                </Select>
              </div>
              <div class="input_single" v-show="btnStyle!=0">
                <div class="font_style_set">按钮颜色:</div>
                <ColorPicker size="small" v-model="btnColor" recommend class="input_content select_cls"/>
              </div>
              <div class="input_single" style="height: 60px;margin-bottom:10px" v-show="btnStyle== '4'">
                <div class="font_style_set">按钮logo:</div>
                  <div class="input_content" style="width: fit-content;">
                    <div class="demo-upload-list">
                      <el-upload
                        class="avatar-uploader"
                        :action="baseUploadUrl"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :on-error="handleAvatarError"
                        :before-upload="handleUpload">
                        <img v-if="btnLogoPath" :src="btnLogoPath" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                      <!-- <img :src="btnLogoPath">
                      <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :format="['jpg','jpeg','png']"
                        :max-size="500"
                        :before-upload="handleUpload"
                        :action="baseUploadUrl"
                        :success="handleAvatarSuccess"
                        style="display: inline-block;width:58px;">
                        <div class="demo-upload-list-cover">上传</div>
                      </Upload> -->

                    </div>

                  </div>
                   <p style="line-height: 100px;color:red;margin-left:10px">格式为jpg/jpeg/png,大小不超过500kb</p>
              </div>
              <div class="input_single" style="margin-top:0px;" v-show="btnStyle== '4'">
                  <!-- <div class="font_style_set">展示大小</div> -->
                  <div style="width: 25%;height: inherit;text-align: right;padding-right: 10px;line-height: 26px;">展示大小</div>
                  <span class="span_must">*</span><span style="margin-right:5px;height: inherit;line-height: 26px;">宽度</span>
                  <input v-model="btnWidth"  type="number"  oninput="value=value.replace(/[^\d]/g, '')"  style="width:20%;height: 25px;border: 1px solid #dcdee2;color:#515a6e;padding-left:5px"></Input>
                  <span style="margin-left:5px;height: inherit;line-height: 26px;">像素</span>
                  <span style="margin-right:5px;margin-left:25px;height: inherit;line-height: 26px;"><span class="span_must">*</span>高度</span>
                  <input v-model="btnHeight" type="number"  oninput="value=value.replace(/[^\d]/g, '')" style="width:20%;height: 25px;border: 1px solid #dcdee2;color:#515a6e;padding-left:5px"></Input>
                  <span style="margin-left:5px;height: inherit;line-height: 26px;">像素</span>
              </div>
              <div class="input_single" style="margin-top:0px;" v-show="btnStyle!=0">
                <div class="font_style_set">按钮位置:</div>
                <el-radio-group v-model="btnPosition" style="transform: translateY(20%);">
                  <el-radio :label="'1'">左侧</el-radio>
                  <el-radio :label="'2'">右侧</el-radio>
                  <el-radio :label="'3'">左侧垂直居中</el-radio>
                  <el-radio :label="'4'">右侧垂直居中</el-radio>
                </el-radio-group>
              </div>
              <div class="input_single" style="margin-top:0px;" v-show="btnStyle!=0">
                <div class="font_style_set">窗口弹出样式:</div>
                <el-radio-group v-model="ejectWindow" style="transform: translateY(20%);">
                  <el-radio :label="'1'">新标签页</el-radio>
                  <el-radio :label="'2'">内嵌窗口</el-radio>
                </el-radio-group>
              </div>
          </div>
    </div>
    <div slot="footer">
      <Button  type="primary" class="submit_btn"  @click="save()">确认</Button>
      <Button type="error" class="cancel_btn"   @click="cancel()">取消</Button>
    </div>
  </Modal>
</template>

<script>
import {publicFunClass} from '@/components/js/PublicFunClass.js'

export default {
  name: 'InsertpagePop',
  mixins: [publicFunClass],
  props: {
    showInsertpage: Boolean,
    searchId: String,
    seachName:String,
  },
  data() {
    return {
      model: false,
      title: '添加网页',
      baseUploadUrl:this.baseURL+"common/upload.json?type=chatLogo&companyNo="+localStorage.getItem("companyId"),

      channelName:'', //名称
      channelPeriod: '0', //是否分时段
      channelType: '-7',

      channelAllocatType: '1', //分配类型，1导航菜单、2员工
          channelAllocatStrategy:'1', //不开启分时段分配策略
          channelAllocatNavList:'', //不开启分时段分配策略
          channelAllocatEmpList:'', //不开启分时段分配策略
          // 开启分时段策略
          channelWorkStrategy:'1', //上班
          channelWorkNavList:[], //上班
          channelWorkEmpList:[], //上班
          channelWorkType: '1', //分配类型，1导航菜单、2员工

          channelHomeStrategy:'1', //下班
          channelHomeEmpList:[], //下班
          channelHomeNavList:[], //下班
          channelHomeType: '1', //分配类型，1导航菜单、2员工

          channelHolidayStrategy:'1',//节假日
          channelHolidayEmpList:[],//节假日
          channelHolidayNavList:[],//节假日
          channelHolidayType: '1', //分配类型，1导航菜单、2员工
          strategyList:[{id: '1', 'name': '随机分配'},{id: '2', 'name': '上次服务优先分配'},{id: '3', 'name': '当前会话数量最少分配'},{id: '4', 'name': '技能等级优先分配'}],
          // channelNavList: [{id: '1',label: '售前服务'},{id: '2',label: '售后服务'}],
          // employeeList:[{id: '2',label: '8000'},{id: '3',label: '8001'},{id: '4',label: '8002'}],
          channelNavList:[],
          chatEmpList:[],



          imagePath:'',
          btnName: '',
          btnStyle: '1',
          btnColor: '#00B5FF',
          //btnLogoPath:require('../../../assets/image/upload.png'),
          btnLogoPath:'',
          btnWidth:'',
          btnHeight:'',
          btnPosition:'4',
          ejectWindow:'1',
    }
  },
  methods: {
    cancel: function () {
      this.$emit('closeInsertpage', false)
    },
    save: function () {
      if(!this.channelName){
          this.$Modal.info({
              title:'提示',
              content:"请输入网页名称"
            });
          return false;
      }
      if(!this.btnName){
          this.$Modal.info({
              title:'提示',
              content:"请输入按钮名称"
            });
          return false;
      }
      if(this.btnStyle== '4'&&this.btnLogoPath==''){
          this.$Modal.info({
              title:'提示',
              content:"请上传按钮图片"
            });
          return false;
      }
      if(this.btnStyle== '4'&&(this.btnWidth==''||this.btnHeight=='')){
          this.$Modal.info({
              title:'提示',
              content:"请设置展示大小"
            });
          return false;
      }
      //未开启分时段
      if(this.channelPeriod === '0'){
        if(this.channelAllocatType === '1' && !this.channelAllocatNavList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"分配导航菜单不能为空"
          });
          return false;
        }
        if(this.channelAllocatType === '2' && !this.channelAllocatEmpList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"分配员工不能为空"
          });
          return false;
        }
      }else{
        //开启分时段
        if(this.channelWorkType === '1' && !this.channelWorkNavList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"工作时间分配导航菜单不能为空"
          });
          return false;
        }
        if(this.channelWorkType === '2' && !this.channelWorkEmpList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"工作时间分配员工不能为空"
          });
          return false;
        }

        if(this.channelHomeType === '1' && !this.channelHomeNavList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"下班时间分配导航菜单不能为空"
          });
          return false;
        }
        if(this.channelHomeType === '2' && !this.channelHomeEmpList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"下班时间分配员工不能为空"
          });
          return false;
        }

        if(this.channelHolidayType === '1' && !this.channelHolidayNavList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"节假日分配导航菜单不能为空"
          });
          return false;
        }
        if(this.channelHolidayType === '2' && !this.channelHolidayEmpList.toString()){
          this.$Modal.info({
            title:'提示',
            content:"节假日分配员工不能为空"
          });
          return false;
        }
      }

      if(this.btnStyle== '4'&&(this.btnWidth=='0'||this.btnHeight=='0')){
          this.$Modal.info({
              title:'提示',
              content:"按钮宽高不能设置为0"
            });
          return false;
      }
      let journalType = "";
      let menuId = "";
      if(this.searchId){
        journalType = "系统管理=>会话配置=>渠道管理=>编辑";
        menuId = "3_12-1-2";
      }else{
        journalType = "系统管理=>会话配置=>渠道管理=>添加";
        menuId = "3_12-1-5";
      }
      let param = {
            "id": this.searchId,
            "channelName": this.channelName,
            "channelType": this.channelType,
            "channelPeriod": this.channelPeriod,
            "channelAllocatStrategy": this.channelPeriod == "0" ? this.channelAllocatStrategy : "",
            "channelAllocatList": this.channelPeriod == "0" ? "{'list':'"+ (this.channelAllocatType == '1' ? this.channelAllocatNavList : this.channelAllocatEmpList) +"','type':'"+this.channelAllocatType+"'}" : "{}",
            "channelWorkStrategy": this.channelPeriod == "1" ? this.channelWorkStrategy : "",
            "channelWorkList": this.channelPeriod == "1" ? "{'list':'"+ (this.channelWorkType == '1' ? this.channelWorkNavList : this.channelWorkEmpList) +"','type':'"+this.channelWorkType+"'}" : "{}",
            "channelHomeStrategy": this.channelPeriod == "1" ? this.channelHomeStrategy : "",
            "channelHomeList": this.channelPeriod == "1" ? "{'list':'"+ (this.channelHomeType == '1' ? this.channelHomeNavList : this.channelHomeEmpList) +"','type':'"+this.channelHomeType+"'}" : "{}",
            "channelHolidayStrategy": this.channelPeriod == "1" ? this.channelHolidayStrategy : "",
            "channelHolidayList": this.channelPeriod == "1" ? "{'list':'"+ (this.channelHolidayType == '1' ? this.channelHolidayNavList : this.channelHolidayEmpList) +"','type':'"+this.channelHolidayType+"'}" : "{}",
            //"channelOther": "{'btnName':'"+this.btnName+"','btnStyle':'"+this.btnStyle+"','btnColor':'"+this.btnColor+"','btnLogoPath':'"+this.btnLogoPath+"','btnPosition':'"+this.btnPosition+"'}",
           // "channelOther": JSON.parse("{'btnName':'"+this.btnName+"','btnStyle':'"+this.btnStyle+"','btnColor':'"+this.btnColor+"','btnLogoPath':'"+this.btnLogoPath+"','btnPosition':'"+this.btnPosition+"'}"),
            "channelOther":JSON.parse('{"btnName":"'+this.btnName+'","btnStyle":"'+this.btnStyle+'","btnColor":"'+this.btnColor+'","btnLogoPath":"'+this.btnLogoPath+'","btnPosition":"'+this.btnPosition+'","ejectWindow":"'+this.ejectWindow+'","btnWidth":"'+this.btnWidth+'","btnHeight":"'+this.btnHeight+'"}'),
            "journalType": journalType,
            "menuId": menuId
          }
          let that = this;
          this.$http.post("chat/channel/doSave.json",param) .then(function (res) {
            let result=res.data;
            that.spinShow=false;
            if(result.flag!="666"){
              that.$Message.error(result.msg);
              return false;
            }
            that.$Message.success(result.msg);
            that.$emit('closeInsertpage', true);
          })
    },
    initSearch: function () {
          let param;
          if(!this.searchId) {//添加
            param = {
              id:'-1',
              channelType:'-7',
              channelName:this.seachName,
              journalType: "系统管理=>会话配置=>渠道管理=>查询",
              menuId: "3_12-1"
            }
            let that = this;
            this.$http.post("chat/channel/toIndex.json",param) .then(function (res) {
                that.channelNavList= res.data.obj.chatNavList;
                that.chatEmpList=res.data.obj.chatEmpList;
            })
          }else{//编辑
              param = {
                id:this.searchId,
                channelType:'-7',
                channelName:this.seachName,
                journalType: "系统管理=>会话配置=>渠道管理=>查询",
                menuId: "3_12-1"
              }

              let that = this;
              this.$http.post("chat/channel/toIndex.json",param) .then(function (res) {
              let result=res.data.flag;
              that.spinShow=false;
              if(result!="666"){
                that.$Message.error(res.data.msg);
                return false;
              }

              that.channelNavList= res.data.obj.chatNavList;//
              that.chatEmpList=res.data.obj.chatEmpList;//
              let channel=res.data.obj.list.content[0];
              that.channelName = channel.channelName;

              that.channelPeriod = channel.channelPeriod; //是否分时段

              if (channel.channelAllocatStrategy){
                that.channelAllocatStrategy = channel.channelAllocatStrategy; //不开启分时段分配策略
              }else{
                that.channelAllocatStrategy = "1"; //不开启分时段分配策略
              }

              if(channel.channelAllocatList){
                that.channelAllocatType = JSON.parse(channel.channelAllocatList).type;
                if (that.channelAllocatType == '1'){
                  that.channelAllocatNavList = JSON.parse(channel.channelAllocatList).list.split(',');
                }else{
                  that.channelAllocatEmpList = JSON.parse(channel.channelAllocatList).list.split(',');
                }
              }else{
                that.channelAllocatType = "1";
                that.channelAllocatNavList = [];
                that.channelAllocatEmpList = [];
              }

              // 开启分时段策略
              //上班
              if (channel.channelWorkStrategy){
                that.channelWorkStrategy = channel.channelWorkStrategy;
              }else{
                that.channelWorkStrategy = "1";
              }

              if(channel.channelWorkList){
                that.channelWorkType = JSON.parse(channel.channelWorkList).type;
                if (that.channelWorkType == '1'){
                  that.channelWorkNavList = JSON.parse(channel.channelWorkList).list.split(',');
                }else{
                  that.channelWorkEmpList = JSON.parse(channel.channelWorkList).list.split(',');
                }
              }else{
                that.channelWorkType = "1";
                that.channelWorkNavList = [];
                that.channelWorkEmpList = [];
              }
              //下班
              if (channel.channelHomeStrategy){
                that.channelHomeStrategy = channel.channelHomeStrategy;
              }else{
                that.channelHomeStrategy = "1";
              }

              if(channel.channelHomeList){
                //下班
                that.channelHomeType = JSON.parse(channel.channelHomeList).type;
                if (that.channelHomeType == '1'){
                  that.channelHomeNavList = JSON.parse(channel.channelHomeList).list.split(',');
                }else{
                  that.channelHomeEmpList = JSON.parse(channel.channelHomeList).list.split(',');
                }
              }else{
                that.channelHomeType = "1";
                that.channelHomeEmpList = [];
                that.channelHomeNavList = [];
              }
              //节假日
              if (channel.channelHolidayStrategy){
                that.channelHolidayStrategy = channel.channelHolidayStrategy;
              }else{
                that.channelHolidayStrategy = "1";
              }

              if(channel.channelHolidayList){
                //节假日
                that.channelHolidayType = JSON.parse(channel.channelHolidayList).type;
                if (that.channelHolidayType == '1'){
                  that.channelHolidayNavList = JSON.parse(channel.channelHolidayList).list.split(',');
                }else{
                  that.channelHolidayEmpList = JSON.parse(channel.channelHolidayList).list.split(',');
                }
              }else{
                that.channelHolidayType = "1";
                that.channelHolidayEmpList = [];
                that.channelHolidayNavList = [];
              }

              // 按钮配置
              if (channel.channelOther){
                that.btnName = JSON.parse(channel.channelOther).btnName;
                that.btnStyle = JSON.parse(channel.channelOther).btnStyle;
                that.btnColor = JSON.parse(channel.channelOther).btnColor;
                that.btnLogoPath =JSON.parse(channel.channelOther).btnLogoPath;
                that.btnPosition = JSON.parse(channel.channelOther).btnPosition;
                that.ejectWindow = JSON.parse(channel.channelOther).ejectWindow;
                that.btnWidth=JSON.parse(channel.channelOther).btnWidth;
                that.btnHeight=JSON.parse(channel.channelOther).btnHeight;

              }
            })
          }
    },
    handleUpload(file){
      let fileSize=parseInt(file.size/1024);
      let type=file.name.substr(file.name.length-4,4);
      if (!(type.indexOf("jpg")!=-1 || type.indexOf("jpeg")!=-1 || type.indexOf("png")!=-1)) {
        this.$Modal.info({
          title:'提示',
          content:"文件"+file.name+"类型必须为jpg/jpeg/png"
        });
        return false;
      }
      if (fileSize>500) {
        this.$Modal.info({
          title:'提示',
          content:"文件"+file.name+"尺寸太大,头像不能超过500KB"
        });
        return false;
      }
    },
    handleAvatarSuccess(res, file) {
      // this.fileList=[];
      // let param={
      //   name:file.name,
      //   url:file.url,
      //   status:file.status,
      // };
      // this.fileList.push(param);
      // if (response.flag!="666") {
      //   this.$Modal.info({
      //     title:'提示',
      //     content:response.msg
      //   });
      //   this.icontitle="上传失败";
      //   return false;
      // }
      this.$Modal.info({
            title:'提示',
            content:res.msg
          });
      this.btnLogoPath=this.baseImgURL+file.response.obj.absolutePath;
    },
    handleAvatarError(err, file){
      this.percentage=err;
      this.$Modal.info({
            title:'失败提示',
            content:file.response.msg
      });
    },
    //

  },
  watch: {
    channelAllocatType:function(){
      if('1' == this.channelAllocatType){
        this.channelAllocatEmpList = '';
      }else{
        this.channelAllocatNavList = '';
      }
    },
    channelWorkType:function(){
      if('1' == this.channelWorkType){
        this.channelWorkEmpList = '';
      }else{
        this.channelWorkNavList = '';
      }
    },
    channelHomeType:function(){
      if('1' == this.channelHomeType){
        this.channelHomeEmpList = '';
      }else{
        this.channelHomeNavList = '';
      }
    },
    channelHolidayType:function(){
      if('1' == this.channelHolidayType){
        this.channelHolidayEmpList = '';
      }else{
        this.channelHolidayNavList = '';
      }
    },
    showInsertpage: function () {
      this.model = this.showInsertpage
      this.title = '添加网页';

      if(this.showInsertpage){

          this.channelName='';
          this.channelPeriod= '0';
          this.channelAllocatStrategy='1';
          this.channelAllocatType='1';
          this.channelAllocatNavList='';
          this.channelAllocatEmpList='';
          this.channelWorkStrategy='1';
          this.channelWorkType='1';
          this.channelWorkNavList=[];
          this.channelWorkEmpList=[];

          this.channelHomeStrategy='1';
          this.channelHomeEmpList=[];
          this.channelHomeNavList=[];
          this.channelHomeType='1';

          this.channelHolidayStrategy='1';
          this.channelHolidayEmpList=[];
          this.channelHolidayNavList=[];
          this.channelHolidayType='1';

          this.btnName='';
          this.btnStyle='1';
          this.btnColor='#00B5FF';
          this.btnLogoPath='';
          this.btnPosition='4';
          this.ejectWindow='1';
          this.btnWidth='30';
          this.btnHeight='30';
          if (this.searchId) {
            this.title = '编辑网页'
            this.initSearch()
          }else{
            this.title = '添加网页'
            this.initSearch()
          }
      }

      console.log(this.baseURL+"common/upload.json?type=chatLogo&companyNo="+localStorage.getItem("companyId"));
    }
  }

}
</script>

<style scoped >
.select_cls{
  height: 30px !important;
  overflow-y:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/InsertpagePop.vue